<template>
  <div class="line-items-table-body-item px-i">
    <div class="line-items-table-cell col-8 d-none d-sm-block">
      {{ name }}
    </div>
    <div class="line-items-table-cell mb-2 col-24 d-sm-none">
      {{ name }}
    </div>
    <div class="line-items-table-cell col-4 col-sm-3">
      <p class="line-items-table-cell-label d-sm-none">
        Qty
      </p>
      {{ quantity }}
    </div>
    <div class="line-items-table-cell col-3 col-sm-4">
      <template v-if="tax && tax.id">
        <p class="line-items-table-cell-label d-sm-none">
          Tax
        </p>
        {{ tax.rate | formatPercentage }}
      </template>
    </div>
    <div class="line-items-table-cell col-8 col-sm-4">
      <p class="line-items-table-cell-label d-sm-none">
        Price
      </p>
      {{ price | formatCurrency(currency.iso_code) }}
    </div>
    <div class="line-items-table-cell col-9 col-sm-5">
      <p class="line-items-table-cell-label d-sm-none">
        Amount
      </p>
      <span>
        {{ amount | formatCurrency(currency.iso_code) }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "TableLineItem",

  props: {
    name: { type: String },
    quantity: { type: [Number, String] },
    price: { type: [Number, String] },
    amount: { type: [Number, String] },
    tax: { type: Object },
    currency: { type: Object }
  }
};
</script>
